module.exports = __webpack_public_path__ + "static/logo-md-2679590b871a604d52cd76ee944afb57.svg";